module.exports = __webpack_public_path__ + "static/img/top-bgimg.2e5baf5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/huarong/top-bgimg.png
// module id = Wic3
// module chunks = 1